export enum AuditPersonType {
    AUDITOR = 1,
    AUDITED = 2,
}